import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonUtility } from '@app/_modules/commonUtility';
import { CategoryService } from '@app/_services/category.service';
import { SweetAlertService } from '@app/_services/sweet-alert.service';

@Component({
  selector: 'app-qr-fee-details',
  templateUrl: './qr-fee-details.component.html',
  styleUrls: ['./qr-fee-details.component.less'],
})
export class QrFeeDetailsComponent implements OnInit {
  form: FormGroup;
  forms: FormGroup;
  JSON;
  isgPay_url: string;
  todayDate: Date;

  @ViewChild('txnForm') txnForm: any;
  tranxnForm: FormGroup;
  submitBtnMsg: String;
  submitBtnMsgClass: String = 'wrappper';
  commonUtility: CommonUtility;
  loading = false;
  name: any = '';
  initialCap: any;
  submitted = false;
  fathersName: any = '';
  courseLoader = false;
  course: any;
  semester: any;
  semesterList: any;
  source: any;
  type: any = '';
  req: any;
  amount: any;
  row: any = '';
  contractNo: any;
  panNo: any;
  customerName: any;
  totalAmount: any;
  myDIV: Boolean = false;
  dataSource: any;
  disableSelect;
  totalFees: any;
  EncDataField: string;
  MerchantIdField: string;
  TransactionId: string;
  BankIdField: string;
  TerminalIdField: string;
  VersionField: string;
  showTable: Boolean = false;
  totalDisabled: boolean = true;
  verified: boolean = false;
  isVerificationPending: boolean = true;
  isVerified: boolean = false;
  studentData: any;
  resStatusCode;
  termsAccepted: boolean = false;
  invoiceAmount;
  checkboxValue: boolean = false;
  formSubmitted: boolean = false;
  dialogRef: any;
  isPopupVisible = false;
  // Email:string;
  // Phone:string;
  // FirstName:string;
  // LastName:string;
  emailId: string;
  mobileNo: string;
  firstName: string;
  lastName: string;

  constructor(
    private sweetalert: SweetAlertService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private categoryService: CategoryService,
    public dialog: MatDialog
  ) //  private sweetalert: SweetAlertService
  {
    this.JSON = JSON;
    this.isgPay_url = categoryService.isgPay_url;
    this.commonUtility = this.categoryService.commonUtility;
  }

  maxValue(event) {
    if (event.target.value && event.target.max) {
      if (
        event.which != 8 &&
        event.which != 46 &&
        event.which != 37 &&
        event.which != 39 &&
        event.which != 9
      ) {
        if (event.target.value.length > <number>event.target.max - 1) {
          event.preventDefault();
        }
      }
    }
  }
  ngOnInit(): void {
    this.todayDate = new Date();
    this.tranxnForm = this.formBuilder.group({
      Version: [''],
      TerminalId: [''],
      BankId: [''],
      MerchantId: [''],
      EncData: [''],
      TransactionId: [''],
      // Email:[''],
      // Phone:[''],
      // FirstName:[''],
      // LastName:['']
      emailId: [''],
      mobileNo: [''],
      firstName: [''],
      lastName: [''],
    });
    this.form = this.formBuilder.group({
      vanNumber: [
        '',
        [Validators.required, Validators.pattern('^[a-zA-Z0-9 ]*$')],
      ],
      customerName: [
        '',
        [Validators.required, Validators.pattern('^[a-zA-Z ]+$'), Validators.maxLength(30)],
      ],
      emailId: [
        '',
        [
          Validators.pattern(
            '^[A-Za-z0-9]([A-Za-z0-9._%+-]{0,120})+@[A-Za-z0-9-_]+(\\.[A-Za-z]{2,10}){1,2}$'
          ),
          Validators.maxLength(150),
        ],
      ],
      mobileNo: [
        '',
        [Validators.required, Validators.pattern('[1-9][0-9]{9}$')],
      ],
      amount: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
      //   inrAmount: [""]
    });

    //this.Cap();
  }

  get f() {
    return this.form.controls;
  }

  onInput(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const value = inputElement.value;
    const sanitizedValue = value.replace(/[^a-zA-Z0-9]/g, '');
    inputElement.value = sanitizedValue;
    this.form.get('vanNumber')?.setValue(sanitizedValue, { emitEvent: false });
  }

  submitQrDetails(): void {
    if (!this.form.controls.amount.value) {
      this.commonUtility.alertMsg('Please Enter Amount ', '', false);
    } else if (this.form.controls.amount.value == 0) {
      this.commonUtility.alertMsg('Amount Should Not be Zero', '', false);
    } else if (!this.checkboxValue) {
      this.commonUtility.alertMsg('Please Accept Terms & Conditions', '', false);
      return;
     } else {
      if (this.form.invalid) {
        return;
      }

      let req = {
        vanNumber: this.form.controls.vanNumber.value.toString(),
        customerName: this.form.controls.customerName.value.toString(),
        emailId: this.form.controls.emailId.value.toString(),
        mobileNo: this.form.controls.mobileNo.value.toString(),
        amount: this.form.controls.amount.value.toString(),
        source: 'QR',
      };

      //const encodedCaptcha = btoa(this.form.controls.captcha.value);

      this.categoryService.submitQrDetails(req).subscribe(
        (res) => {
          if (res.body.statusCode === '00000') {
            this.tranxnForm.controls.EncData.setValue(
              res.body.data.fields.EncData
            );
            this.tranxnForm.controls.MerchantId.setValue(
              res.body.data.fields.MerchantId
            );
            this.tranxnForm.controls.BankId.setValue(
              res.body.data.fields.BankId
            );
            this.tranxnForm.controls.TerminalId.setValue(
              res.body.data.fields.TerminalId
            );
            this.tranxnForm.controls.Version.setValue(
              res.body.data.fields.Version
            );
            this.tranxnForm.controls.TransactionId.setValue(
              res.body.data.fields.TransactionId
            );
            this.tranxnForm.controls.emailId.setValue(
              res.body.data.fields.emailId
            );
            this.tranxnForm.controls.mobileNo.setValue(
              res.body.data.fields.mobileNo
            );
            this.tranxnForm.controls.firstName.setValue(
              res.body.data.fields.firstName
            );
            this.tranxnForm.controls.lastName.setValue(
              res.body.data.fields.lastName
            );

            this.EncDataField = res.body.data.fields.EncData;
            this.MerchantIdField = res.body.data.fields.MerchantId;
            this.BankIdField = res.body.data.fields.BankId;
            this.TerminalIdField = res.body.data.fields.TerminalId;
            this.VersionField = res.body.data.fields.Version;
            this.txnForm.nativeElement.submit();
          } else {
            this.commonUtility.alertMsg(res.body.statusDesc, '', false);
          }
          this.loading = false;
        },
        (error) => {
          this.commonUtility.alertMsg(
            JSON.stringify(error.statusText),
            '',
            false
          );
        }
      );
    }
  }

  hideError(controlName) {
    this.form.controls[controlName].markAsUntouched();
    if (
      this.submitBtnMsgClass &&
      this.submitBtnMsgClass.indexOf('alertBlock') > -1
    ) {
      this.submitBtnMsgClass = 'wrapper';
    }
    if (this.submitBtnMsg && this.submitBtnMsg.indexOf('a') > -1) {
      this.submitBtnMsg = '';
    }
  }

  // ValidCaptcha(){
  //   let str1=this.initialCap
  //   let str2=this.form.get('captcha').value;
  //   if(str2.toUpperCase()!="") {
  //   if(str1 == str2.toUpperCase()){
  //     this.form.controls['captcha'].setErrors(null);
  //     return true;
  //   }else{
  //     this.form.controls['captcha'].setErrors({'incorrectcaptcha': true});
  //     return false;
  //   }
  //   }
  //   else {
  //     this.commonUtility.alertMsg('Please try again invalid Captcha','',false);
  //   }
  // }

  // Cap() {
  //   let alpha = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  //    var apl1 = alpha[Math.floor(Math.random() * 36)];
  //    var apl2 = alpha[Math.floor(Math.random() * 36)];
  //    var apl3 = alpha[Math.floor(Math.random() * 36)];
  //    var apl4 = alpha[Math.floor(Math.random() * 36)];
  //    var apl5 = alpha[Math.floor(Math.random() * 36)];
  //    var apl6 = alpha[Math.floor(Math.random() * 36)];
  //    this.initialCap = apl1 + apl2 + apl3 + apl4 + apl5 + apl6;

  //    }

  openTermsAndConditionsPopup(event: Event) {
    // Prevent default action of the hyperlink
    event.preventDefault();

    // Display Sweet Alert to show terms and conditions
    this.sweetalert.errorAlert(
      'Terms & Conditions',
      `
      <html>
      <div style="font-size: 16px; text-align: left;">
          <p>These terms and conditions apply to the Customer who uses this Online Payment Services for the purchase of Dental Products from Nobel Biocare India Pvt. Ltd. Please read these terms and conditions carefully. By authorizing a payment to Nobel Biocare India Pvt. Ltd. through this online payment service (“the service”), it would be treated as a deemed acceptance of these terms and conditions. Nobel Biocare India Pvt. Ltd. reserves all the rights to amend these terms and conditions at any time without giving prior notice. It is the responsibility of the Customer to read the terms and conditions before using the Service.</p>
          <h2>Key Terms:</h2>
          <p>Before using this Service, it is recommended that the Customer shall review the charges or fees payable against the available online payment methods and verify the amount payable to Nobel Biocare India Pvt. Ltd.</p>
          <p>The Customer agrees, understands and confirms that his/ her personal data including without limitation details relating to online payment methods is transmitted over the Internet Payment Gateway may be susceptible to misuse, hacking, theft and/ or fraud and that Nobel Biocare India Pvt. Ltd. or the Payment Service Provider(s) have no control over such matters.</p>
          <p>Nobel Biocare India Pvt. Ltd. and/or the Payment Service Providers shall not be liable for any inaccuracy, error or delay in, or omission of (a) any data, information or message, or (b) the transmission or delivery of any such data, information or message; or (c) any loss or damage arising from or occasioned by any such inaccuracy, error, delay or omission, non-performance or interruption in any such data, information or message. Under no circumstances shall Nobel Biocare India Pvt. Ltd. and/or the Payment Service Providers, its employees, directors, and its third party agents involved in processing, delivering or managing the Services, be liable for any direct, indirect, incidental, special or consequential damages, or any damages whatsoever, including punitive or exemplary arising out of or in any way connected with the provision of or any inadequacy or deficiency in the provision of the Services or resulting from unauthorized access or alteration of transmissions of data or arising from suspension or termination of the Service.</p>
          <p>The Customer agrees that Nobel Biocare India Pvt. Ltd. or any of its employees will not be held liable for any loss or damages arising from the use of Internet Payment Gateway, or reliance upon the information contained on the Website, or any failure to comply with these Terms and Conditions where such failure is due to circumstance beyond Nobel Biocare India Pvt. Ltd. reasonable control.</p>
          <h2>Non – Binding</h2>
          <p>Please note that this privacy policy does not create any contractual or other legal rights in or on behalf of any party, nor is it intended to do so.</p>
          <h2>Prohibited Actions</h2>
          <ul>
            <li>While using this Site, you agree not to, by any means (including hacking, cracking or defacing any portion of the Site) indulge in illegal or unauthorized activities including the following:</li>
            <li>Restrict or inhibit any authorized user from using this Site</li>
            <li>Use the Site for unlawful purposes</li>
            <li>Harvest or collect information about Site users without their express consent</li>
            <li>“Frame” or “mirror” any part of the Site without our prior authorization</li>
            <li>Engage in spamming or flooding</li>
            <li>Transmit any software or other materials that contain any virus, time bomb, or other harmful or disruptive component</li>
            <li>Remove any copyright, trademark or other proprietary rights notices contained in the Site</li>
            <li>Use any device, application or process to retrieve, index, “data mine” or in any way reproduce or circumvent the navigational structure or presentation of the Site</li>
          </ul>
          <h2>Variations to the Terms and Conditions</h2>
          <p>Nobel Biocare India Pvt. Ltd. reserves the right to vary these Terms and Conditions from time to time and the current version will be that published on this website. Nobel Biocare India Pvt. Ltd. may also make additions/deletions/alterations to the services offered, at its sole discretion. Nobel Biocare India Pvt. Ltd. reserves the right to withdraw the service at any time at its discretion and/ or retains the right to change the terms and conditions for Online Payments, without any prior notice.</p>
      </div>
      </html>
    `,
      ''
    );
  }
}
